import { render, staticRenderFns } from "./PlanSelector.vue?vue&type=template&id=35c1e1e0"
import script from "./PlanSelector.vue?vue&type=script&lang=js"
export * from "./PlanSelector.vue?vue&type=script&lang=js"
import style0 from "./PlanSelector.vue?vue&type=style&index=0&id=35c1e1e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports